{
  "v": "5.9.0",
  "fr": 25,
  "ip": 0,
  "op": 100,
  "w": 1000,
  "h": 1000,
  "nm": "Eat 2",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "plate backie Outlines",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [500, 522, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [30, 27, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [1000, 1000, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0.475, 0.318],
                    [0.554, -0.127],
                    [0.19, -0.206],
                    [0.205, -5.572],
                    [-1.416, -2.795],
                    [-0.244, -0.363],
                    [-0.04, -0.666],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-1.111, 0],
                    [0, 0],
                    [0, 0],
                    [-0.184, 1.638],
                    [0, 0]
                  ],
                  "o": [
                    [-0.374, -0.25],
                    [-0.303, 0.07],
                    [-2.76, 2.97],
                    [-0.112, 3.068],
                    [0.17, 0.333],
                    [0.482, 0.716],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.229, 1.647],
                    [0, 0],
                    [0, 0],
                    [1.098, -0.011],
                    [0, 0],
                    [-0.065, -0.395]
                  ],
                  "v": [
                    [3.02, -24.518],
                    [1.594, -24.703],
                    [0.866, -24.175],
                    [-3.627, -3.993],
                    [-2.108, 4.333],
                    [-1.441, 5.404],
                    [-0.372, 7.598],
                    [-1.321, 22.382],
                    [-1.323, 22.415],
                    [-1.319, 22.447],
                    [1.246, 24.831],
                    [1.266, 24.831],
                    [1.268, 24.831],
                    [3.739, 22.454],
                    [3.737, -23.268]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.156862969492, 0.333332944384, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 1, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0, "y": 0.968 },
                    "o": { "x": 0.402, "y": 0 },
                    "t": 0,
                    "s": [54.176, 26.578],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0.343, "y": 0.987 },
                    "o": { "x": 0.831, "y": 0 },
                    "t": 16,
                    "s": [63.176, 26.578],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0.239, "y": 1 },
                    "o": { "x": 0.556, "y": 0 },
                    "t": 44,
                    "s": [37.499, 26.578],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 75, "s": [54.176, 26.578] }
                ],
                "ix": 2
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0], "y": [0.983] },
                    "o": { "x": [0.402], "y": [0] },
                    "t": 0,
                    "s": [0]
                  },
                  {
                    "i": { "x": [0.343], "y": [0.998] },
                    "o": { "x": [0.831], "y": [0] },
                    "t": 16,
                    "s": [17]
                  },
                  {
                    "i": { "x": [0.239], "y": [1] },
                    "o": { "x": [0.556], "y": [-0.011] },
                    "t": 44,
                    "s": [-31.744]
                  },
                  { "t": 75, "s": [0] }
                ],
                "ix": 6
              },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 3",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-0.657, 1.175],
                    [-0.383, 1.052],
                    [0.135, 1.605],
                    [-0.04, 1.049],
                    [0.687, 0.533],
                    [0.491, -0.146],
                    [0.067, -0.939],
                    [-0.006, -1.173],
                    [0.069, -1.087],
                    [0.045, -0.229],
                    [0.013, -0.09],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.392, -0.047],
                    [0.078, -0.674],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.03, 0.152],
                    [0.011, 0.164],
                    [-0.005, 1.128],
                    [0.079, 1.128],
                    [0.478, 0.355],
                    [0.493, -0.112],
                    [0.054, -0.478],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0.092, -5.624],
                    [0, 0],
                    [0.053, -0.754],
                    [-0.199, -1.445],
                    [-1.272, 0],
                    [0, 0],
                    [-0.225, 2.034],
                    [0, 0]
                  ],
                  "o": [
                    [0.396, -1.214],
                    [0.582, -1.044],
                    [0.442, -1.219],
                    [-0.1, -1.19],
                    [0.051, -1.387],
                    [-0.277, -0.215],
                    [-0.585, 0.173],
                    [-0.079, 1.132],
                    [0.004, 1.112],
                    [-0.011, 0.161],
                    [-0.017, 0.086],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.292, -0.732],
                    [-0.54, 0.064],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.012, -0.08],
                    [-0.035, -0.176],
                    [-0.071, -1.09],
                    [0.005, -1.16],
                    [-0.051, -0.712],
                    [-0.266, -0.198],
                    [-0.599, 0.136],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [-0.194, 5.739],
                    [0, 0],
                    [-0.012, 0.756],
                    [-0.105, 1.522],
                    [0.223, 1.622],
                    [0, 0],
                    [1.233, -0.022],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [2.1, -4.152],
                    [3.831, -7.756],
                    [5.398, -10.931],
                    [5.566, -15.414],
                    [5.387, -21.211],
                    [4.809, -24.703],
                    [3.661, -24.804],
                    [2.865, -22.801],
                    [2.796, -19.283],
                    [2.736, -15.935],
                    [2.648, -15.382],
                    [2.602, -15.118],
                    [2.564, -14.843],
                    [1.372, -14.835],
                    [1.059, -23.85],
                    [1.036, -23.958],
                    [-0.26, -24.854],
                    [-1.275, -23.657],
                    [-1.555, -14.835],
                    [-2.745, -14.843],
                    [-2.786, -15.118],
                    [-2.842, -15.429],
                    [-2.919, -15.935],
                    [-2.98, -19.319],
                    [-3.049, -22.806],
                    [-3.637, -24.679],
                    [-4.766, -24.802],
                    [-5.555, -23.654],
                    [-5.84, -11.808],
                    [-2.266, -4.1],
                    [-2.268, -4.023],
                    [-2.65, 13.157],
                    [-2.693, 15.77],
                    [-2.812, 18.059],
                    [-2.829, 22.601],
                    [0.051, 24.95],
                    [0.105, 24.95],
                    [3.083, 22.164],
                    [2.083, -4.097]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.156862969492, 0.333332944384, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 1, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": 0, "y": 0.976 },
                    "o": { "x": 0.402, "y": 0 },
                    "t": 0,
                    "s": [7.636, 26.678],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0.343, "y": 0.987 },
                    "o": { "x": 0.831, "y": 0 },
                    "t": 16,
                    "s": [-4.364, 26.678],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  {
                    "i": { "x": 0.239, "y": 1 },
                    "o": { "x": 0.556, "y": 0 },
                    "t": 44,
                    "s": [22.205, 26.678],
                    "to": [0, 0],
                    "ti": [0, 0]
                  },
                  { "t": 75, "s": [7.636, 26.678] }
                ],
                "ix": 2
              },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0], "y": [1.018] },
                    "o": { "x": [0.402], "y": [0] },
                    "t": 0,
                    "s": [0]
                  },
                  {
                    "i": { "x": [0.343], "y": [1] },
                    "o": { "x": [0.831], "y": [0] },
                    "t": 16,
                    "s": [-16]
                  },
                  {
                    "i": { "x": [0.239], "y": [1] },
                    "o": { "x": [0.556], "y": [-0.01] },
                    "t": 44,
                    "s": [31.112]
                  },
                  { "t": 75, "s": [0] }
                ],
                "ix": 6
              },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 4",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [6.285, 0],
                    [0, -6.285],
                    [-6.285, 0],
                    [0, 6.286]
                  ],
                  "o": [
                    [-6.285, 0],
                    [0, 6.286],
                    [6.285, 0],
                    [0, -6.285]
                  ],
                  "v": [
                    [0, -11.399],
                    [-11.399, 0],
                    [0, 11.399],
                    [11.399, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.156862969492, 0.333332944384, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [30.18, 27.587], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 2",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [6.986, 0],
                    [0, 6.985],
                    [-6.985, 0],
                    [0, -6.986]
                  ],
                  "o": [
                    [-6.985, 0],
                    [0, -6.986],
                    [6.986, 0],
                    [0, 6.985]
                  ],
                  "v": [
                    [-0.004, 12.661],
                    [-12.673, -0.007],
                    [-0.004, -12.676],
                    [12.665, -0.007]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [10.726, 0],
                    [0, -10.726],
                    [-10.727, 0],
                    [0, 10.726]
                  ],
                  "o": [
                    [-10.727, 0],
                    [0, 10.726],
                    [10.726, 0],
                    [0, -10.726]
                  ],
                  "v": [
                    [0, -19.453],
                    [-19.453, 0],
                    [0, 19.453],
                    [19.453, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "mm",
              "mm": 1,
              "nm": "Merge Paths 1",
              "mn": "ADBE Vector Filter - Merge",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0, 0.156862969492, 0.333332944384, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [30.183, 27.59], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 5",
          "np": 4,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "st",
          "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 3 },
          "o": { "a": 0, "k": 100, "ix": 4 },
          "w": { "a": 0, "k": 1.7, "ix": 5 },
          "lc": 1,
          "lj": 1,
          "ml": 4,
          "bm": 0,
          "nm": "Stroke 2",
          "mn": "ADBE Vector Graphic - Stroke",
          "hd": false
        },
        {
          "ty": "st",
          "c": { "a": 0, "k": [0, 0.156860351563, 0.333312988281, 1], "ix": 3 },
          "o": { "a": 0, "k": 100, "ix": 4 },
          "w": { "a": 0, "k": 3.7, "ix": 5 },
          "lc": 1,
          "lj": 1,
          "ml": 6,
          "bm": 0,
          "nm": "Stroke 1",
          "mn": "ADBE Vector Graphic - Stroke",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 250,
      "st": 0,
      "bm": 0
    }
  ],
  "markers": []
}
